var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyCustomModelSideDrawer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 218,
    height: 168,
    viewBox: "0 0 218 168",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8380",
    "data-name": "Group 8380",
    transform: "translate(-16 -16.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8380-2",
    "data-name": "Group 8380"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4136",
    "data-name": "Path 4136",
    d: "M229,16.5H21a5,5,0,0,0-5,5v158a5,5,0,0,0,5,5H229a5,5,0,0,0,5-5V21.5A5,5,0,0,0,229,16.5Z",
    fill: "#e6ebf4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4137",
    "data-name": "Path 4137",
    d: "M66,36.5H31a5,5,0,0,0-5,5v111a5,5,0,0,0,5,5H66a5,5,0,0,0,5-5V41.5A5,5,0,0,0,66,36.5Z",
    fill: "#f8f9fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4138",
    "data-name": "Path 4138",
    d: "M219,36.5H89a5,5,0,0,0-5,5v111a5,5,0,0,0,5,5H219a5,5,0,0,0,5-5V41.5A5,5,0,0,0,219,36.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4139",
    "data-name": "Path 4139",
    d: "M219.5,165.5h-35a4.5,4.5,0,0,0,0,9h35a4.5,4.5,0,0,0,0-9Z",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4140",
    "data-name": "Path 4140",
    d: "M30,30.5a4,4,0,1,0-4-4A4,4,0,0,0,30,30.5Z",
    fill: "#769eb0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4141",
    "data-name": "Path 4141",
    d: "M43,30.5a4,4,0,1,0-4-4A4,4,0,0,0,43,30.5Z",
    fill: "#769eb0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4142",
    "data-name": "Path 4142",
    d: "M55.5,30.5a4.272,4.272,0,0,0,4.5-4,4.531,4.531,0,0,0-9,0A4.272,4.272,0,0,0,55.5,30.5Z",
    fill: "#769eb0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4143",
    "data-name": "Path 4143",
    d: "M65.5,46.5h-33a1.5,1.5,0,0,0,0,3h33a1.5,1.5,0,0,0,0-3Z",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4144",
    "data-name": "Path 4144",
    d: "M52.5,51.5h-20a1.5,1.5,0,0,0,0,3h20a1.5,1.5,0,0,0,0-3Z",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8381",
    "data-name": "Group 8381"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4145",
    "data-name": "Path 4145",
    d: "M141,48.5H101v40h40Z",
    fill: "#7e9dae"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8382",
    "data-name": "Group 8382"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4146",
    "data-name": "Path 4146",
    d: "M141,104.5H101v40h40Z",
    fill: "#7e9dae"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8383",
    "data-name": "Group 8383"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4147",
    "data-name": "Path 4147",
    d: "M207,48.5H167v40h40Z",
    fill: "#7e9dae"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8384",
    "data-name": "Group 8384"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4148",
    "data-name": "Path 4148",
    d: "M207,104.5H167v40h40Z",
    fill: "#7e9dae"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4149",
    "data-name": "Path 4149",
    d: "M166,74.321V64.288l5.016,5.016L166,74.319Z",
    fill: "#d8e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4150",
    "data-name": "Path 4150",
    d: "M126.5,65.5h-17a1.5,1.5,0,0,0,0,3h17a1.5,1.5,0,0,0,0-3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4151",
    "data-name": "Path 4151",
    d: "M126.5,121.5h-17a1.5,1.5,0,0,0,0,3h17a1.5,1.5,0,0,0,0-3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4152",
    "data-name": "Path 4152",
    d: "M192.5,65.5h-17a1.5,1.5,0,0,0,0,3h17a1.5,1.5,0,0,0,0-3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4153",
    "data-name": "Path 4153",
    d: "M192.5,121.5h-17a1.5,1.5,0,0,0,0,3h17a1.5,1.5,0,0,0,0-3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4154",
    "data-name": "Path 4154",
    d: "M119.5,70.5h-10a1.5,1.5,0,0,0,0,3h10a1.5,1.5,0,0,0,0-3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4155",
    "data-name": "Path 4155",
    d: "M119.5,126.5h-10a1.5,1.5,0,0,0,0,3h10a1.5,1.5,0,0,0,0-3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4156",
    "data-name": "Path 4156",
    d: "M185.5,70.5h-10a1.5,1.5,0,0,0,0,3h10a1.5,1.5,0,0,0,0-3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4157",
    "data-name": "Path 4157",
    d: "M185.5,126.5h-10a1.5,1.5,0,0,0,0,3h10a1.5,1.5,0,0,0,0-3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4158",
    "data-name": "Path 4158",
    d: "M141.058,125.3h26.831",
    fill: "none",
    stroke: "#d8e4f9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4159",
    "data-name": "Path 4159",
    d: "M141,129.5a4,4,0,1,0-4-4A4,4,0,0,0,141,129.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4160",
    "data-name": "Path 4160",
    d: "M141,128.5a3,3,0,1,0-3-3A3,3,0,0,0,141,128.5Z",
    fill: "none",
    stroke: "#d8e4f9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4161",
    "data-name": "Path 4161",
    d: "M166,130.321V120.288l5.016,5.016L166,130.319Z",
    fill: "#d8e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4162",
    "data-name": "Path 4162",
    d: "M141.058,69.3h26.831",
    fill: "none",
    stroke: "#d8e4f9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4163",
    "data-name": "Path 4163",
    d: "M141,73.5a4,4,0,1,0-4-4A4,4,0,0,0,141,73.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4164",
    "data-name": "Path 4164",
    d: "M141,72.5a3,3,0,1,0-3-3A3,3,0,0,0,141,72.5Z",
    fill: "none",
    stroke: "#d8e4f9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4165",
    "data-name": "Path 4165",
    d: "M66.5,165.5h-36a4.5,4.5,0,0,0,0,9h36a4.5,4.5,0,0,0,0-9Z",
    fill: "#7e9dae"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCustomModelSideDrawer);
export default __webpack_public_path__ + "static/media/empty-custom-model-side-drawer.37bebecc3814f948380eb255ce0db29e.svg";
export { ForwardRef as ReactComponent };